import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { globals } from '../globals';
import { ModeloDeEstatistica, TipoDeEstatistica } from '../models/enum';
import { EstatisticaSintetica } from '../models/estatistica-sintetica';

@Injectable({
  providedIn: 'root'
})
export class EstatisticaService {

  constructor(private http: HttpClient) { }

  consultarEstatisticaSintetica(modelo: ModeloDeEstatistica, tipo: TipoDeEstatistica, dataHoraInicio?, dataHoraTermino?, idTime?,
    idVendedor?, idIntegrador?) {

    let parametros = new HttpParams()
      .set('tipo', tipo.toString());

    if (dataHoraInicio !== undefined && dataHoraInicio !== null) {
      parametros = parametros.set('dataHoraInicio', dataHoraInicio);
    }

    if (dataHoraTermino !== undefined && dataHoraTermino !== null) {
      parametros
        = parametros.set('dataHoraTermino', dataHoraTermino);
    }

    if (idTime !== undefined && idTime !== null) {
      parametros = parametros.set('idTime', idTime);
    }

    if (idVendedor !== undefined && idVendedor !== null) {
      parametros = parametros.set('idVendedor', idVendedor);
    }

    if (idIntegrador !== undefined && idIntegrador !== null) {
      parametros = parametros.set('idIntegrador', idIntegrador);
    }

    return this.http.get<EstatisticaSintetica>(globals.apiUrl + '/api/v2/bi/estatistica/sintetico/' + modelo,
      {
        params: parametros
      });
  }

  consultarListaEstatisticaSintetica(modelos: ModeloDeEstatistica[], tipo: TipoDeEstatistica, dataHoraInicio?, dataHoraTermino?, idTime?,
    idVendedor?, idIntegrador?) {

    let parametros = new HttpParams()
      .set('tipo', tipo.toString());

    modelos.forEach(p => parametros = parametros.append('modelos', p.toString()));

    if (dataHoraInicio !== undefined && dataHoraInicio !== null) {
      parametros = parametros.set('dataHoraInicio', dataHoraInicio);
    }

    if (dataHoraTermino !== undefined && dataHoraTermino !== null) {
      parametros
        = parametros.set('dataHoraTermino', dataHoraTermino);
    }

    if (idTime !== undefined && idTime !== null) {
      parametros = parametros.set('idTime', idTime);
    }

    if (idVendedor !== undefined && idVendedor !== null) {
      parametros = parametros.set('idVendedor', idVendedor);
    }

    if (idIntegrador !== undefined && idIntegrador !== null) {
      parametros = parametros.set('idIntegrador', idIntegrador);
    }

    return this.http.get<EstatisticaSintetica[]>(globals.apiUrl + '/api/v2/bi/estatistica/sintetico',
      {
        params: parametros
      });
  }
}
